import { Injectable } from '@angular/core';
import {
  FetchUserFilters,
  FetchUserFiltersFail,
  FetchUserFiltersSuccess,
  UpdateUserFilters,
  UpdateUserFiltersFail,
  UserFilterActionTypes
} from '@app/pcs/actions/user-filter';
import { UserFilter } from '@app/pcs/models';
import * as fromPcs from '@app/pcs/reducer';
import { UserFilterDataService } from '@app/pcs/services/user-filter-data.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { hasValue, mapPayload } from '@util';
import { of } from 'rxjs';
import { catchError, exhaustMap, switchMap, withLatestFrom } from 'rxjs/operators';

@Injectable()
export class UserFilterEffects {

  fetchFilters$ = createEffect(() => this.actions$.pipe(
    ofType<FetchUserFilters>(UserFilterActionTypes.FetchUserFilters),
    withLatestFrom(this.store.pipe(select(fromPcs.getAllFilters))),
    exhaustMap(([forceFetch, cachedFilters]) => !forceFetch && hasValue(cachedFilters)
      ? of(new FetchUserFiltersSuccess(cachedFilters))
      : this.userFilterDataService.fetchFilters().pipe(
        switchMap((filters: UserFilter[]) => of(new FetchUserFiltersSuccess(filters))),
        catchError(error => of(new FetchUserFiltersFail(error)))
      )
    )
  ));

  updateUserFilters$ = createEffect(() => this.actions$.pipe(
    ofType<UpdateUserFilters>(UserFilterActionTypes.UpdateUserFilters),
    mapPayload(),
    exhaustMap((userFilters: UserFilter[]) =>
      this.userFilterDataService.updateUserFilters(userFilters).pipe(
        switchMap((updatedUserFilters: UserFilter[]) => of(new FetchUserFiltersSuccess(updatedUserFilters))),
        catchError((error: Error) => of(new UpdateUserFiltersFail(error)))
      )
    )
  ));

  constructor(private store: Store<fromPcs.State>,
    private actions$: Actions,
    private userFilterDataService: UserFilterDataService) {
  }
}
